"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Badge = void 0;
const tslib_1 = require("tslib");
// import { Badge as RNPBadge } from 'react-native-paper';
const components_1 = require("@bluebase/components");
const Badge_1 = tslib_1.__importDefault(require("@material-ui/core/Badge"));
const component_mapper_1 = require("@bluebase/component-mapper");
exports.Badge = component_mapper_1.componentMapper(Badge_1.default, {
    badgeContent: ({ children }) => children,
    color: () => {
        return 'error';
    },
}, { rest: true, ignore: ['children'] });
exports.Badge.defaultProps = components_1.BadgeDefaultProps;
